angular.module('satv.playlist.pitch', [
    'satv.playlist',
    'satv.mediastats',
    'ngResource',
    'satv.loader',
    'satv.user',
    'satv.urlbuilder',
    'ui.tinymce'
], ['$interpolateProvider', function($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/module.js